//// constant json menu
export const menus = [
  {
    id: 1,
    label: "TimeSheet",
    state: "/timesheet",
    component: "Timesheet",
    roles: ["admin"],
    parentId: 0,
    activeKey: "timesheet",
    children: [
      {
        id: 7,
        label: "TimeSheet",
        state: "/timesheet",
        component: "Timesheet",
        roles: ["admin"],
        parentId: 1,
        activeKey: "timesheet",
      },
      {
        id: 8,
        label: "Request Management",
        state: "/timesheet/request-management",
        component: "RequestManage",
        roles: ["admin"],
        parentId: 1,
        activeKey: "request-management",
      },
      {
        id: 9,
        label: "Onsite Management",
        state: "/timesheet/onsite-management",
        component: "OnsiteManagement",
        roles: ["admin"],
        parentId: 1,
        activeKey: "onsite-management",
      },
      {
        id: 10,
        label: "Explanation Management",
        state: "/timesheet/explanation-management",
        component: "ExplainManage",
        roles: ["admin"],
        parentId: 1,
        activeKey: "explanation-management",
      },
      {
        id: 11,
        label: "Delegation Management",
        state: "/timesheet/delegation-management",
        component: "DelegationManage",
        roles: ["admin"],
        parentId: 1,
        activeKey: "delegation-management",
      },
      {
        id: 12,
        label: "Abnormal Case",
        state: "/timesheet/abnormal-case",
        component: "AbnormalCase",
        roles: ["admin"],
        parentId: 1,
        activeKey: "abnormal-case",
      },
      {
        id: 13,
        label: "Check In-Out Time",
        state: "/timesheet/checkin-checkout",
        component: "CheckinOut",
        roles: ["admin"],
        parentId: 1,
        activeKey: "checkin-checkout",
      },
      {
        id: 14,
        label: "Special Explanation",
        state: "/timesheet/special-explanation",
        component: "CheckinOut",
        roles: ["admin"],
        parentId: 1,
        activeKey: "special-explanation",
      },
    ],
  },
  {
    id: 2,
    label: "Payroll",
    state: "/payroll",
    component: "Payroll",
    roles: ["admin"],
    parentId: 0,
    activeKey: "payroll",
    children: [
      {
        id: 14,
        label: "Payroll Report Detail",
        state: "/payroll/payroll-report-detail",
        component: "PayrollReportDetail",
        roles: ["admin"],
        parentId: 2,
        activeKey: "payroll-detail",
      },
      {
        id: 15,
        label: "Check In - Check Out Report",
        state: "/report/checkInOut-TMS-report",
        component: "PayrollReportCheckInOut",
        roles: ["admin"],
        parentId: 2,
        activeKey: "payroll-inout",
      },
    ],
  },
  {
    id: 3,
    label: "Report",
    state: "/report",
    component: "Report",
    roles: ["admin"],
    children: [],
    parentId: 0,
    activeKey: "report",
  },
  {
    id: 5,
    label: "Setting",
    state: "/settings",
    component: "Setting",
    roles: ["admin"],
    children: [],
    parentId: 0,
    activeKey: "settings",
  },
  {
    id: 6,
    label: "Logs",
    state: "/logs",
    component: "Logs",
    roles: ["admin"],
    children: [],
    parentId: 0,
    activeKey: "logs",
  },
];

//// constant json filters
export const filtersJson = {
  timesheet: {
    page: "Timesheet",
    key: "/timesheet",
    controls: [
      {
        label: "Choose a Payroll Period",
        placeholder: "Choose a Payroll Period",
        name: "payroll_period",
        type: "select",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Location",
        placeholder: "Location",
        name: "location",
        type: "multiple-select",
      },
      {
        label: "Division",
        placeholder: "Division",
        name: "divisions",
        type: "multiple-select",
      },
      {
        label: "Department",
        placeholder: "Department",
        name: "departmentsFilter",
        type: "multiple-select",
      },
      {
        label: "Work Schedule Type",
        placeholder: "Work Schedule Type",
        name: "workScheduleTypes",
        type: "multiple-select",
      },
      {
        label: "Role",
        placeholder: "Role",
        name: "role",
        type: "multiple-select",
        isToggle: true,
      },
      {
        label: "Search by request",
        placeholder: "Search by reason",
        name: "reason_type",
        type: "multiple-select",
        isToggle: true,
      },
      {
        label: "Abnormal Value",
        placeholder: "Abnormal Value",
        name: "abnormal_case",
        type: "checkbox",
      },
    ],
  },
  timesheet_user: {
    page: "TimesheetUser",
    key: "/timesheet",
    controls: [
      {
        label: "Choose a Payroll Period",
        placeholder: "Choose a Payroll Period",
        name: "payroll_period",
        type: "select",
      },
    ],
  },
  request_management: {
    page: "Request Management",
    key: "/timesheet/request-management",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Request Type",
        placeholder: "Search by request type",
        key: "request_type",
        name: "requestType",
        type: "multiple-select",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Search by status",
        placeholder: "Search by status",
        name: "status",
        type: "multiple-select",
      },
      {
        label: "Department",
        placeholder: "Department",
        name: "department",
        type: "multiple-select",
      },
      {
        label: "Search",
        placeholder: "Search by approver",
        name: "approver",
        type: "auto-complete",
      },
      {
        label: "Request reason",
        placeholder: "Search by reason",
        key: "request",
        name: "reason_type",
        type: "multiple-select",
      },
      {
        label: "Only Me",
        placeholder: "Only Me",
        name: "onlyMe",
        type: "checkbox",
      },
    ],
  },
  request_management_by_staff: {
    page: "Request Management",
    key: "/timesheet/request-management_by_staff",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Request Type",
        placeholder: "Search by request type",
        key: "request_type",
        name: "requestType",
        type: "multiple-select",
      },
      {
        label: "Search by status",
        placeholder: "Search by status",
        name: "status",
        type: "multiple-select",
      },
      {
        label: "Request reason",
        placeholder: "Search by reason",
        key: "request",
        name: "reason_type",
        type: "multiple-select",
      },
    ],
  },
  explanation_management: {
    page: "Explanation management",
    key: "/timesheet/explanation-management",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Status",
        placeholder: "Status",
        name: "status",
        type: "multiple-select",
      },
      {
        label: "Department",
        placeholder: "Department",
        name: "department",
        type: "multiple-select",
      },
      {
        label: "Reason Type",
        placeholder: "Reason Type",
        name: "reason_type",
        type: "multiple-select",
      },
    ],
  },
  explanation_management_by_staff: {
    page: "Explanation management",
    key: "/timesheet/explanation-management",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Status",
        placeholder: "Status",
        name: "status",
        type: "multiple-select",
      },
      {
        label: "Reason Type",
        placeholder: "Reason Type",
        name: "reason_type",
        type: "multiple-select",
      },
    ],
  },
  onsite_management: {
    page: "Onsite Management",
    key: "/timesheet/onsite-management",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Status",
        placeholder: "Status",
        name: "status-onsite",
        type: "multiple-select",
      },
      {
        label: "Department",
        placeholder: "Department",
        name: "department",
        type: "multiple-select",
      },
      {
        label: "Search",
        placeholder: "Search by approver",
        name: "approver",
        type: "auto-complete",
      },
      {
        label: "Adjustment",
        placeholder: "Adjustment",
        name: "adjustment",
        type: "select",
      },
      {
        label: "Project",
        placeholder: "Search by Project",
        name: "projects",
        type: "auto-complete",
        // type: "multiple-select",
      },
    ],
  },
  overtime_management_staff: {
    page: "Overtime-Management",
    key: "/timesheet/overtime-management",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Status",
        placeholder: "Status",
        name: "status",
        type: "multiple-select",
      },
      {
        label: "Search",
        placeholder: "Search by manager",
        name: "assignee",
        type: "auto-complete",
      },
      {
        label: "OT type",
        placeholder: "Overtime type",
        name: "otType",
        type: "multiple-select",
      },
      {
        label: "Project",
        placeholder: "Search by Project",
        name: "projects",
        type: "auto-complete",
        // type: "multiple-select",
      },
    ],
  },
  overtime_management: {
    page: "Overtime-Management",
    key: "/timesheet/overtime-management",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Status",
        placeholder: "Status",
        name: "status",
        type: "multiple-select",
      },
      {
        label: "Department",
        placeholder: "Department",
        name: "department",
        type: "multiple-select",
      },
      {
        label: "Search",
        placeholder: "Search by manager",
        name: "assignee",
        type: "auto-complete",
      },
      {
        label: "OT type",
        placeholder: "Overtime type",
        name: "otType",
        type: "multiple-select",
      },
      {
        label: "Project",
        placeholder: "Search by Project",
        name: "projects",
        type: "auto-complete",
        // type: "multiple-select",
      },
      {
        label: "Only Me",
        placeholder: "Only Me",
        name: "onlyMe",
        type: "checkbox",
      },
    ],
  },
  abnormal_case: {
    page: "Abnormal Case",
    key: "/timesheet/abnormal-case",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "employee",
        type: "auto-complete",
      },
      // {
      //   label: "Status",
      //   placeholder: "Search by Status",
      //   name: "status",
      //   type: "multiple-select",
      // },
      {
        label: "Department",
        placeholder: "Search by Department",
        name: "department",
        type: "multiple-select",
      },
      // {
      //   label: "Search",
      //   placeholder: "Search by approver",
      //   name: "assignee",
      //   type: "auto-complete",
      // },
      {
        label: "Reason type",
        placeholder: "Search by Abnomal Type",
        name: "request_type",
        type: "multiple-select",
      },
      // {
      //   label: "Actual",
      //   placeholder: "Search by actual",
      //   name: "actual",
      //   type: "multiple-select",
      // },
      // {
      // 	label: 'Role',
      // 	placeholder: 'Search by Role',
      // 	name: 'role',
      // 	type: 'multiple-select'
      // },
      // {
      // 	label: 'Absent type',
      // 	placeholder: 'Absent type',
      // 	name: 'absent_type',
      // 	type: 'multiple-select'
      // },
    ],
  },
  abnormal_case_staff: {
    page: "Abnormal Case",
    key: "/timesheet/abnormal-case",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      // {
      //   label: "Status",
      //   placeholder: "Search by Status",
      //   name: "status",
      //   type: "multiple-select",
      // },
      {
        label: "Reason type",
        placeholder: "Search by Abnomal Type",
        name: "request_type",
        type: "multiple-select",
      },
      // {
      //   label: "Actual",
      //   placeholder: "Search by actual",
      //   name: "actual",
      //   type: "multiple-select",
      // },
      // {
      // 	label: 'Absent type',
      // 	placeholder: 'Absent type',
      // 	name: 'absent_type',
      // 	type: 'multiple-select'
      // },
    ],
  },
  delegation_management: {
    delegation_list: {
      page: "Delegation Management",
      key: "/timesheet/delegation-management",
      tab: "delegation_list",
      controls: [
        {
          label: "Period",
          placeholder: "Period",
          name: "period",
          type: "dateRange",
        },
        {
          label: "Member",
          placeholder: "Search by Members ",
          name: "member",
          type: "auto-complete",
        },
        {
          label: "Search",
          placeholder: "Search by Delegator",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
      ],
    },
    // delegation_expalination_request: {
    // 	page: 'Delegation Management',
    // 	key: '/timesheet/delegation-management',
    // 	tab: 'delegation_expalination_request',
    // 	controls: [
    // 		{
    // 			label: 'Period',
    // 			placeholder: 'Period',
    // 			name: 'period',
    // 			type: 'dateRange'
    // 		},
    // 		{
    // 			label: 'Department',
    // 			placeholder: 'Search by Department',
    // 			name: 'department',
    // 			type: 'multiple-select'
    // 		},

    // 		{
    // 			label: 'Status',
    // 			placeholder: 'Search by Status',
    // 			name: 'status',
    // 			type: 'multiple-select'
    // 		},
    // 		{
    // 			label: 'Search',
    // 			placeholder: 'Search by staff name, ldap',
    // 			name: 'employee',
    // 			type: 'auto-complete'
    // 		},
    // 		{
    // 			label: 'Delegator',
    // 			placeholder: 'Search by Delegator',
    // 			name: 'members',
    // 			type: 'auto-complete'
    // 		},
    // 	],
    // }
  },
  checkin_checkout: {
    page: "Check In-Out Time",
    key: "/timesheet/checkin-checkout",
    controls: [
      {
        label: "Staff Name",
        placeholder: "Staff Name",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Payroll period",
        placeholder: "Payroll period",
        name: "period",
        type: "dateRange",
      },
    ],
  },
  checkin_checkout_by_staff: {
    page: "Check In-Out Time",
    key: "/timesheet/checkin-checkout",
    controls: [
      {
        label: "Payroll period",
        placeholder: "Payroll period",
        name: "period",
        type: "dateRange",
      },
    ],
  },
  special_explanation: {
    page: "Special Explanation",
    key: "/timesheet/special-explanation",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Department",
        placeholder: "Search by Department",
        name: "departments",
        type: "multiple-select",
      },
      {
        label: "Creator",
        placeholder: "Search by Creator",
        name: "creator",
        type: "auto-complete",
      },
    ],
  },

  payroll_report_detail: {
    page: "Payroll Report Detail",
    key: "/payroll/payroll-report-detail",
    controls: [
      {
        label: "Choose a Payroll Period",
        placeholder: "Choose a Payroll Period",
        name: "timesheetId",
        type: "select",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "userList",
        type: "auto-complete",
      },
      {
        label: "Department",
        placeholder: "Search by Department",
        name: "departments",
        type: "multiple-select",
      },
    ],
  },
  payroll_report_summary: {
    page: "Payroll Report Summary",
    key: "/payroll/payroll-report-detail",
    controls: [
      {
        label: "Choose a Payroll Period",
        placeholder: "Choose a Payroll Period",
        name: "timesheetId",
        type: "select",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "userList",
        type: "auto-complete",
      },
      {
        label: "Department",
        placeholder: "Search by Department",
        name: "departments",
        type: "multiple-select",
      },
    ],
  },

  checkIO_report: {
    page: "Check In - Check Out Report",
    key: "/report/checkInOut-TMS-report",
    controls: [
      {
        label: "Period",
        placeholder: "Period",
        name: "period",
        type: "dateRange",
      },
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "userList",
        type: "auto-complete",
      },
      {
        label: "Department",
        placeholder: "Search by Department",
        name: "departments",
        type: "multiple-select",
      },
      {
        label: "Project",
        placeholder: "Search by Project",
        name: "projects",
        type: "auto-complete",
        // type: "single-select",
      },
    ],
  },

  logs: {
    page: "Logs",
    key: "/logs",
    log_list: {
      page: "Logs List",
      tab: "log_list",
      controls: [
        {
          label: "Period",
          placeholder: "Period",
          name: "period",
          type: "dateRange",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap,",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Search by table",
          placeholder: "Search by table",
          name: "table",
          type: "multiple-select",
        },
      ],
    },
    connection_history: {
      page: "Connection History",
      tab: "connection_history",
      controls: [
        {
          label: "Period",
          placeholder: "Period",
          name: "period",
          type: "dateRange",
        },
      ],
    },
  },
  payroll_list: {
    total_salary: {
      page: "Payroll",
      key: "/payroll",
      tab: "total_salary",
      controls: [
        {
          label: "Choose a Payroll Period",
          placeholder: "Choose a Payroll Period",
          name: "periodId",
          type: "select",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
        {
          label: "Project",
          placeholder: "Search by Project",
          name: "projects",
          type: "auto-complete",
          // type: "multiple-select",
        },
      ],
    },
    salary_in_period: {
      page: "Payroll",
      key: "/payroll",
      tab: "salary_in_period",
      controls: [
        {
          label: "Choose a Payroll Period",
          placeholder: "Choose a Payroll Period",
          name: "periodId",
          type: "select",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
        {
          label: "Project",
          placeholder: "Search by Project",
          name: "projects",
          type: "auto-complete",
          // type: "multiple-select",
        },
      ],
    },
    bonus_in_month: {
      page: "Payroll",
      key: "/payroll",
      tab: "bonus_in_month",
      controls: [
        {
          label: "Choose a Payroll Period",
          placeholder: "Choose a Payroll Period",
          name: "periodId",
          type: "select",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap",
          name: "employees",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
      ],
    },
    onsite: {
      page: "Payroll",
      key: "/payroll",
      tab: "onsite",
      controls: [
        {
          label: "Choose a Payroll Period",
          placeholder: "Choose a Payroll Period",
          name: "periodId",
          type: "select",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
        {
          label: "Role",
          placeholder: "Role",
          name: "role",
          type: "multiple-select",
        },
        {
          label: "Project",
          placeholder: "Search by Project",
          name: "projects",
          type: "auto-complete",
          // type: "multiple-select",
        },
      ],
    },
    overtime: {
      page: "Payroll",
      key: "/payroll",
      tab: "overtime",
      controls: [
        {
          label: "Choose a Payroll Period",
          placeholder: "Choose a Payroll Period",
          name: "periodId",
          type: "select",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
        {
          label: "Role",
          placeholder: "Role",
          name: "role",
          type: "multiple-select",
        },
        {
          label: "Project",
          placeholder: "Search by Project",
          name: "projects",
          type: "auto-complete",
          // type: "multiple-select",
        },
      ],
    },
    paying_cash: {
      page: "Payroll",
      key: "/payroll",
      tab: "paying_cash",
      controls: [
        {
          label: "Choose a Payroll Period",
          placeholder: "Choose a Payroll Period",
          name: "periodId",
          type: "select",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
        {
          label: "Payment Method",
          placeholder: "Search by Payment Method",
          name: "method",
          type: "multiple-select",
        },
      ],
    },
    paying_transfer: {
      page: "Payroll",
      key: "/payroll",
      tab: "paying_transfer",
      controls: [
        {
          label: "Choose a Payroll Period",
          placeholder: "Choose a Payroll Period",
          name: "periodId",
          type: "select",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
      ],
    },
    payroll_tttl: {
      page: "Payroll",
      key: "/payroll",
      tab: "payroll_tttl",
      controls: [
        {
          label: "Choose a Payroll Period",
          placeholder: "Choose a Payroll Period",
          name: "periodId",
          type: "select",
        },
        {
          label: "Search",
          placeholder: "Search by staff name, ldap",
          name: "employee",
          type: "auto-complete",
        },
        {
          label: "Department",
          placeholder: "Department",
          name: "department",
          type: "multiple-select",
        },
      ],
    },
  },
  payslip: {
    page: "Payslip",
    key: "/payroll",
    controls: [
      {
        label: "Choose a Payroll Period",
        placeholder: "Choose a Payroll Period",
        name: "periodId",
        type: "select",
      },
    ],
  },
  employeeList: {
    page: "Employee",
    key: "/employee",
    controls: [
      {
        label: "Search",
        placeholder: "Search by staff name, ldap",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Search",
        placeholder: "Search by SF4C ID",
        name: "sf4cId",
        type: "auto-complete",
      },
      {
        label: "Department",
        placeholder: "Department",
        name: "department",
        type: "multiple-select",
      },
    ],
  },
  employeeSoda: {
    page: "Employee Soda",
    key: "/employee",
    controls: [
      {
        label: "Search",
        placeholder: "Search by Attendance Check ID",
        name: "idSdsv",
        type: "auto-complete",
      },
      {
        label: "Search",
        placeholder: "Search by HRMS ID",
        name: "idLdap",
        type: "auto-complete",
      },
    ],
  },
  job_info_history: {
    page: "Job Info History",
    key: "/employee/job-info-history",
    controls: [
      {
        label: "Search",
        placeholder: "Filter by employee",
        name: "employeeId",
        type: "auto-complete",
      },
    ],
  },

  // annual leave type: bonus leave & leave carryover
  setting_leave_config: {
    page: "Annual leave",
    key: "/settings/leave-config",
    controls: [
      {
        label: "Search",
        placeholder: "Search by staff name, ID",
        name: "employee",
        type: "auto-complete",
      },
      {
        label: "Department",
        placeholder: "Department",
        name: "department",
        type: "multiple-select",
      },
      {
        label: "Location",
        placeholder: "Location",
        name: "location",
        type: "multiple-select",
      },
    ],
  },

  setting_general_configuration: {
    page: "General configuration",
    key: "/settings/leave-management/general-configuration",
    controls: [
      {
        label: "DateApplied",
        placeholder: "DateApplied",
        name: "dateApplied",
        type: "date",
      },
    ],
  },
};

// constant status timesheet
export const statusTimesheet = {
  draft: 0,
  reject: 1,
  pendingUpdate: 2,
  pendingApproval: 3,
  approved: 4,
};

export const statusText = {
  1: "PENDING",
  3: "APPROVED",
  4: "REJECTED",
  5: "CANCELLED",
  0: "EXPLAIN",
  10: "EXPIRED",
};
export const statusName = {
  1: "Pending",
  3: "Approved",
  4: "Rejected",
  5: "Cancelled",
  0: "Explain",
  10: "Expired",
};
export const statusTextReverse = {
  PENDING: 1,
  APPROVED: 3,
  REJECTED: 4,
  CANCELLED: 5,
  EXPLAIN: 0,
  EXPIRED: 10,
};

export const statusColor = {
  DONE: "blue",
  EXPLAIN: "blue",
  APPROVED: "green",
  REJECTED: "red",
  CANCELLED: "",
  PENDING: "orange",
  DELEGATED: "purple",
  EXPIRED: "",
  DELETED: "magenta",
};

export const otType = {
  OT_IN_OFFICE: "OT in office",
  OT_FROM_HOME: "OT from home",
  WORK_OUTSIDE: "Work Outside",
};
export const otTypeFlexible = {
  OT_IN_OFFICE: "OT in office",
  OT_FROM_HOME: "OT from home",
  WORK_OUTSIDE: "Work outside",
};

export const absentType = {
  1: "Full-time leave",
  2: "Morning leave",
  3: "Afternoon leave",
};

export const Role = {
  STAFF: "TMS_Staff_1",
  DULEAD: "TMS_DL_1",
  GROUP_LEAD: "TMS_GL_1",
  HR: "TMS_HR_1",
  HRM: "TMS_HRM_1",
  ADMIN: "TMS_Admin_1",
  GUEST: "TMS_GUEST_1",
};

export const reasonType = {
  1: "Unauthorized Early-Leaving",
  2: "Unauthorized Late-Coming",
  3: "Unauthorized part of the day leave",
  4: "No Check-in",
  5: "No Check-out",
  6: "No Check-in, No Check-out",
};

export const leavingType = [
  {
    type: "ANNUAL",
    name: "Annual Leave",
  },
  { type: "OFFSET", name: "Offset Day" },
];
export const STATUS_FLEXIBLE = [
  {
    key: "PENDING APPROVAL BY PM",
    label: "Pending Approval",
    circle_color: "#FAD229",
    color: "#FAEA85",
    text_color: "#905E0E",
    subLabel: "by Project Manager",
  },
  {
    key: "PENDING CONFIRM BY PM",
    label: "Pending Confirm",
    circle_color: "#FF7A00",
    color: "#FAEA85",
    text_color: "#905E0E",
    subLabel: "by Project Manager",
  },
  {
    key: "REJECTED BY PM",
    label: "Rejected",
    circle_color: "#DD1D3F",
    color: "#F6BBC4",
    text_color: "#AC112D",
    subLabel: "by Project Manager",
  },
  {
    key: "PENDING APPROVAL BY MANAGER",
    label: "Pending Approval",
    circle_color: "#FAD229",
    color: "#FAEA85",
    text_color: "#905E0E",
    subLabel: "by Manager",
  },
  {
    key: "REJECTED BY MANAGER",
    label: "Rejected",
    circle_color: "#DD1D3F",
    color: "#F6BBC4",
    text_color: "#AC112D",
    subLabel: "by Manager",
  },
  {
    key: "APPROVED",
    label: "Approved",
    circle_color: "#27751F",
    color: "#C8F7C4",
    text_color: "#27751F",
  },
  {
    key: "CANCELLED",
    label: "Cancelled",
    circle_color: "#829299",
    color: "#829299",
    text_color: "#14323F",
  },
  {
    key: "EXPIRED",
    label: "Expired",
    circle_color: "#C9D0D3",
    color: "#E3E6E8",
    text_color: "#3D5660",
  },
];

export const STATUS_FLEXIBLE_TEXT = [
  "PENDING APPROVAL BY PM",
  "PENDING CONFIRM BY PM",
  "REJECTED BY PM",
  "PENDING APPROVAL BY MANAGER",
  "REJECTED BY MANAGER",
  "APPROVED",
  "CANCELLED",
  "EXPIRED",
];
export const TIME_STAFF = 16;
export const TIME_PM = 17;

export const MORNING_TYPE = "MORNING";
export const AFTERNOON_TYPE = "AFTERNOON";
export const FULL_DAY_TYPE = "FULL_DAY";

export const DURATION_TYPES = [
  {
    code: FULL_DAY_TYPE,
    label: "Full day",
  },
  {
    code: MORNING_TYPE,
    label: "Morning",
  },
  {
    code: AFTERNOON_TYPE,
    label: "Afternoon",
  },
];

export const LEAVE_REQUEST_TYPE = "LEAVE_REQUEST";
export const EXPLANATION_REQUEST_TYPE = "EXPLANATION_REQUEST";
export const WORK_OUTSIDE_REQUEST_TYPE = "WORK_OUTSIDE_REQUEST";

export const SINGLE_TYPE = "single";
export const MULTIPLY_TYPE = "multiple";

export const REQUEST_TYPES = [
  {
    id: 1,
    code: LEAVE_REQUEST_TYPE,
    label: "Leave Request",
    type: [MULTIPLY_TYPE, SINGLE_TYPE],
  },
  {
    id: 2,
    code: EXPLANATION_REQUEST_TYPE,
    label: "Explanation Request",
    type: [SINGLE_TYPE],
  },
  {
    id: 3,
    code: WORK_OUTSIDE_REQUEST_TYPE,
    label: "Work outside Request",
    type: [MULTIPLY_TYPE],
  },
];

export const REQUEST_TYPE_SHIFT = "SHIFT";
export const REQUEST_TYPE_HOUR = "HOUR";

export const EXPLANATION_REFUND_BY_HOUR = "EXPLANATION_REFUND_BY_HOUR";
export const EXPLANATION_REFUND_BY_DAY = "EXPLANATION_REFUND_BY_DAY";
export const EXPLANATION_NOT_REFUND = "EXPLANATION_NOT_REFUND";

export const FOLDER_NAME_LEAVE_REQUEST = "request";
export const FOLDER_NAME_ABNORMAL = "abnormal-case";

export const OVERTIME_TABS = ["fixedTab", "flexibleTab"];
export const FIXED_TAB = "fixedTab";
export const FLEXIBLE_TAB = "flexibleTab";

export const DATE_FORMAT_V2_FULL = "DD/MM/YYYY HH:mm:ss";
export const DATE_FORMAT_SHORT = "YYYY-MM-DD";
export const DATE_FORMAT_FULL = "YYYY-MM-DD HH:mm:ss";
export const DATE_FORMAT_DMY = "DD-MM-YYYY";
export const DATE_FORMAT_V2 = "DD/MM/YYYY";
export const DATE_FORMAT_HM = "HH:mm";
export const DATE_FORMAT_HMS = "HH:mm:ss";

export const REQUEST_TIME_OFF = "TIME_OFF";
export const REQUEST_WORK_OUTSIDE = "WORK_OUTSIDE";
export const REQUEST_EXPLANATION = "EXPLANATION";

export const REASON_WORK_OUTSIDE = "WORK_OUTSIDE";

export const OT_TYPE_FIXED = "OT_FIXED";
export const OT_TYPE_FIXED_CONFIG = "OT_FIXED_CONFIG";
export const OT_TYPE_FLEXIBLE = "OT_FLEXIBLE";
export const OT_TYPE_FIXED_IGNORE = "OT_FIXED_IGNORE";
export const OT_TYPE_FIXED_CONFIG_IGNORE = "OT_FIXED_CONFIG_IGNORE";
export const OT_TYPE_FLEXIBLE_IGNORE = "OT_FLEXIBLE_IGNORE";

export const CREATE_BY_HR = "HR";
export const CREATE_BY_EMPLOYEE = "EMPLOYEE";

export const ROLE_PROJECT_PM = "PM";

export const LATE_COMING_TYPE = "LATE_COMING";
export const EARLY_LEAVING_TYPE = "EARLY_LEAVING";
export const PARTIAL_OF_DAY_TYPE = "PARTIAL_OF_DAY";
export const LOA_CORP_13_TYPE = "LOA_CORP_13";
export const MATERNITY_LEAVE_TYPE = "LOA_CORP_7";
export const WORKING_TIME_ONSIDE_REQUEST = "WT_ONSITE";

export const ACTUAL_EXPLANATION = [LATE_COMING_TYPE, EARLY_LEAVING_TYPE, PARTIAL_OF_DAY_TYPE, LOA_CORP_13_TYPE];

export const BLOCK = 30;
